import { Col, Flex, Row } from 'antd';
import { WeekdayNumbers } from 'luxon';
import React from 'react';

import { BORDER_MAIN, COUNT_DAY_IN_WEEK, WIDTH_COLUMN_CALENDAR_TIME } from '../const';
import { CUSTOM_WEEK_START } from '../functions';
import useOs from '../hooks/useOs';
import { DayWeekType } from '../types';
import CalendarHeaderDay from './calendarHeaderDay';
import CalendarHeaderItems from './calendarHeaderItems';

interface ICalendarHeaderDayWeek {
    typeDayWeek: DayWeekType;
}

const CalendarHeaderDayWeek: React.FC<ICalendarHeaderDayWeek> = ({ typeDayWeek }) => {
    const os = useOs();

    const isWindows = os === 'Windows';

    return (
        <>
            <Row>
                <Col
                    style={{
                        borderRight: BORDER_MAIN,
                        borderBottom: BORDER_MAIN,
                        width: WIDTH_COLUMN_CALENDAR_TIME,
                    }}
                ></Col>
                <Col
                    style={{
                        borderRight: isWindows ? BORDER_MAIN : 'none',
                        borderBottom: BORDER_MAIN,
                        width: `calc(100% - ${WIDTH_COLUMN_CALENDAR_TIME}px - ${isWindows ? 16 : 0}px)`,
                    }}
                >
                    <Flex justify={'space-around'}>
                        {Array.from<number>({ length: COUNT_DAY_IN_WEEK }).map((_, day) => (
                            <CalendarHeaderDay
                                key={day}
                                typeDayWeek={typeDayWeek}
                                day={((day + CUSTOM_WEEK_START) % 7 || 7) as WeekdayNumbers}
                                index={day}
                            />
                        ))}
                    </Flex>
                    <div style={{ maxHeight: 130, overflow: 'scroll' }}>
                        <CalendarHeaderItems />
                    </div>
                </Col>
            </Row>
        </>
    );
};

export default CalendarHeaderDayWeek;
